import Component from './Component';

export default class SearchPredictive extends Component {
  load() {
    this.timer = {};
    this.lastInput = '';
    this.lastCat = 'x';

    this.initPredictiveSearch();

    super.load();
  }

  initPredictiveSearch() {
    const searchInput = document.getElementById('header-search-input');

    // const overlay = document.getElementById('header-search-predictive-search');

    if (searchInput) {
      searchInput.addEventListener("focus", () => {
        this.setInputCheck();
      });

      searchInput.addEventListener("blur", () => {
        this.resetInputCheck();
      });
    }

    // Adding category filtering
    const footerElem = document.getElementById('predictive-search-footer');

    if (footerElem) {
      footerElem.addEventListener('click', (e) => {
        if (e.target.classList.contains('predictive-search__category')) {
          // Remove existing class
          if (window.currentPredictiveCategoryEl)
            window.currentPredictiveCategoryEl.classList.remove('js-checked');

          // If clicked tag is checked then check the empty tag instead
          if (window.currentPredictiveCategoryEl === e.target) {
            const emptyEl = document.getElementById('predictive-search-radio-empty');
            emptyEl.checked = true;
            window.currentPredictiveCategoryEl = emptyEl;
            this.updateOverlay();
          } else {
            e.target.classList.add('js-checked');
            window.currentPredictiveCategoryEl = e.target;

            const radioElem = e.target.getElementsByClassName('predictive-search__radio')[0];
            radioElem.checked = true;
            this.updateOverlay();
          }
        }
      });
    }

  }

  setInputCheck() {
    this.timer = setInterval(() => {
      this.updateOverlay();
    }, 1500);
  }

  resetInputCheck() {
    clearInterval(this.timer);
  }

  updateOverlay() {
    // const testData = ['Adelaide', 'Adelaide Hills', 'Adelaide Winery', 'Adelaide Trout Farm', 'Clarendon'];
    let apiData = [];
    const overlayResults = document.getElementById('predictive-search-suggestions');
    const overlay = document.getElementById('header-search-predictive-search');
    const searchInput = document.getElementById('header-search-input');
    const inputValue = searchInput.value;
    const selectedCategory = overlay.querySelector('input[name="ra-category"]:checked');
    const cat = selectedCategory ? selectedCategory.value : '';

    // if not valid return
    if (!inputValue || inputValue.length <= 1) {
      overlayResults.innerHTML = '';
      if (!overlay.classList.contains('fade')) {
        overlay.classList.add('fade');
      }
      return;
    }

    // input has changed?
    if (this.lastInput === inputValue && this.lastCat === cat) return;
    this.lastInput = inputValue;
    this.lastCat = cat;

    // Call API
    const url = `/umbraco/api/searchapi/predict?q=${inputValue}` + (cat ? `&c=${cat}` : '');
    $.ajax({
      type: "GET",
      url: url,
      dataType: "html"
    }).done((data) => {
      // clear last results
      overlayResults.innerHTML = '';

      if (!data || data === '[]') {
        // if category used, return 'no results' if nothing returned
        if (cat) {
          let span = document.createElement("span");
          span.innerHTML = 'No Results.'

          overlayResults.appendChild(span);
        } else if (!overlay.classList.contains('fade')) {
          overlay.classList.add('fade');
        }

        return;
      }

      apiData = JSON.parse(data);
      if (!apiData || apiData.length == 0) {
        if (!overlay.classList.contains('fade'))
          overlay.classList.add('fade');
        return;
      }

      // show overlay with results
      overlay.classList.remove('fade');

      apiData.forEach((item) => {
        const li = document.createElement("li");
        let a = document.createElement("a");

        const title = item.Title;
        const index = item.Title.toLowerCase().indexOf(inputValue.toLowerCase());
        if (index >= 0) {
          // innerHTML = innerHTML.substring(0,index) + "<span class='highlight'>" + innerHTML.substring(index,index+text.length) + "</span>" + innerHTML.substring(index + text.length);

          const startText = document.createTextNode(title.substring(0, index));
          const bold = document.createElement("bold");
          bold.innerHTML = title.substring(index, index + inputValue.length);
          const endText = document.createTextNode(title.substring(index + inputValue.length));

          a.appendChild(startText);
          a.appendChild(bold);
          a.appendChild(endText);
        } else {
          const text = document.createTextNode(title);
          a.appendChild(text);
        }

        //let highlightedTitle = item.Title.replace(new RegExp(inputValue, "gi"), (match) => `<bold>${match}</bold>`);

        a.href = item.Url;
        li.appendChild(a);
        overlayResults.appendChild(li);
      });
    }).fail((errorThrown) => {
      console.log(errorThrown);
    });

    //const apiData = testData.filter(s => s.toLowerCase().includes(searchInput.value.toLowerCase()));
  }
}
